import Draggable from 'react-draggable';
import React, { useRef } from 'react';

import { Stack, IconButton } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
function PaperComponent(props) {
  const nodeRef = useRef(null);
  
  return (
    <Draggable 
      nodeRef={nodeRef}
      handle="#draggable-dialog-title" 
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export default function DraggableDialog({
  dialogTitle,
  dialogContent,
  dialogActions,
  open,
  onClose,
  maxWidth,
  dialogSubTitle = '',
  showSubTitle = false,
  disableBackdropClick,
}) {
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={disableBackdropClick ? handleClose : onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      maxWidth={maxWidth ?? 'md'}
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {dialogTitle}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        {showSubTitle && <>{dialogSubTitle}</>}
      </DialogTitle>

      <DialogContent>{dialogContent}</DialogContent>
      <DialogActions>{dialogActions}</DialogActions>
    </Dialog>
  );
}